import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';

@Injectable({
    providedIn: 'root'
})
export class InformationPageService extends BaseService {

    constructor(protected http: HttpClient) {
        super();
    }

    public PAGES = {
        FOOTER_LEFT_SIDE: 'footer_left_side',
        FOOTER_BOTTOM_SIDE: 'footer_bottom_side',
        ABOUT_US: 'about_us',
        CONTACT: 'contact',
        TERMS_AND_CONDS: 'terms_and_conds',
        HOW_TO_BUY: 'how_to_buy',
        CONTRACT_EMAIL: 'contract_email',
        INFO_BANK_TRANSFER: 'info_bank_transfer',
        payments_methods: 'payments_methods',
        privacy: 'privacy',
    }

    public getAllInformationPages() {
        return this.http.get<RequestResponse>(this.getUrl('getAllInformationPages'));
    }

    public updateInformationPage(desc: string, lang: string, content: string) {
        return this.http.post<RequestResponse>(this.getUrl('updateInformationPage'), { desc: desc, lang: lang, content: content });
    }

    public getInformationPage(desc: string, lang: string) {
        return this.http.post<RequestResponse>(this.getUrl('getInformationPage'), { desc: desc, lang: lang });
    }

    public contactform(data) {
        return this.http.post<RequestResponse>(this.getUrl('contactform'), data);
    }
    public suggestForm(data) {
        return this.http.post<RequestResponse>(this.setUrl('suggestSong'), data);
    }
}
